import { render } from "./MyOrders.vue?vue&type=template&id=0edf455e&scoped=true&ts=true"
import script from "./MyOrders.vue?vue&type=script&lang=ts"
export * from "./MyOrders.vue?vue&type=script&lang=ts"

import "./MyOrders.vue?vue&type=style&index=0&id=0edf455e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_typescript@5.9.3__webpack@5.109.2_postcss@8.5.26_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0edf455e"]])

export default __exports__